import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState
} from 'react';
import PropTypes from 'prop-types';
import { getSweepsByConsumerId } from '../api/sweepstakeApi';
import { SWEEP_CONSUMER_ID } from '../config';

const SweepsContext = createContext({
    sweeps: [],
    loading: true,
    error: null,
    findSweepById: () => null,
    refetch: () => {}
});

export const SweepsProvider = ({ children }) => {
    const [sweeps, setSweeps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSweeps = useCallback(async () => {
        setLoading(true);
        setError(null);

        const { data, errorMessage } = await getSweepsByConsumerId({
            consumerId: SWEEP_CONSUMER_ID
        });

        if (errorMessage) {
            setError(errorMessage);
            setSweeps([]);
        } else {
            setSweeps(data);
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        fetchSweeps();
    }, [fetchSweeps]);

    const findSweepById = useCallback(
        sweepId => sweeps.find(s => s.sweepId === sweepId) || null,
        [sweeps]
    );

    return (
        <SweepsContext.Provider
            value={{
                sweeps,
                loading,
                error,
                findSweepById,
                refetch: fetchSweeps
            }}
        >
            {children}
        </SweepsContext.Provider>
    );
};

SweepsProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useSweeps = () => useContext(SweepsContext);

export { SweepsContext };
